export const COMPANY_NAME = "UNIQUE RIDES INC";
export const COMPANY_SHORT = "Unique Rides";
export const COMPANY_INITIALS = "UR";
export const COMPANY_ADDRESS_FULL = "6422 Whitsett Ave APT 204, North Hollywood, CA 91606-2349";
export const COMPANY_LOCATION = "North Hollywood, CA";
export const COMPANY_REGION = "Los Angeles County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=6422%20Whitsett%20Ave%20APT%20204%2C%20North%20Hollywood%2C%20CA%2091606-2349";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1433086966358-54859d0ed716?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "Unique Rides" },
  { "label": "Service Area", "value": "Los Angeles County" },
  { "label": "Location", "value": "North Hollywood, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "UNIQUE RIDES INC" },
  { "label": "City / State", "value": "North Hollywood, CA" },
  { "label": "Address", "value": "6422 Whitsett Ave APT 204, North Hollywood, CA 91606-2349" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "TODO: Pillar 1", "body": "TODO: Customize." },
  { "icon": "✦", "title": "TODO: Pillar 2", "body": "TODO: Customize." },
  { "icon": "✿", "title": "TODO: Pillar 3", "body": "TODO: Customize." },
  { "icon": "❍", "title": "TODO: Pillar 4", "body": "TODO: Customize." },
];
